'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var innnerPageStyles = function innnerPageStyles(_ref) {
  var theme = _ref.theme,
    backgroundColor = _ref.backgroundColor;
  return {
    backgroundColor: backgroundColor || theme.Page_backgroundColor,
    width: '100%',
    maxWidth: theme.pageWidthLimit || undefined,
    margin: '0 auto'
  };
};
exports.default = (0, _glamorous2.default)('div')(innnerPageStyles);